var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "f7-panel",
    { staticClass: "panelBackground", attrs: { left: "" } },
    [
      _c(
        "div",
        [
          _c(
            "f7-link",
            {
              staticClass: "headbandTextColor",
              attrs: { "close-picker": "", "close-panel": "left" },
            },
            [_c("i", { staticClass: "fa-solid fa-xmark iconRemovePanel" })]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("mobile-language-picker"),
      _vm._v(" "),
      _vm.hasRightHRTP && _vm.hasRightSRTP
        ? _c("mobile-norm-picker", { attrs: { checkedNorm: _vm.checkedNorm } })
        : _vm._e(),
      _vm._v(" "),
      _c("mobile-identity-header", { attrs: { username: _vm.userName } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "overflow-y-auto overflow-x-hidden h-100vh" },
        [
          _c(
            "mobile-menu-container",
            [
              _c("mobile-menu-section-list-item", {
                staticClass: "profileInformationContainer",
                attrs: { labelId: "leftPanelTitle.accueil" },
                on: {
                  click: function ($event) {
                    return _vm.goToLink("/home/")
                  },
                },
              }),
              _vm._v(" "),
              _c("mobile-menu-section-list-item", {
                staticClass: "profileInformationContainer",
                attrs: { labelId: "leftPanelTitle.my_prfl" },
                on: {
                  click: function ($event) {
                    return _vm.goToLink("/profile/")
                  },
                },
              }),
              _vm._v(" "),
              this.accountType === "1"
                ? _c("mobile-menu-section-list-item", {
                    staticClass: "profileInformationContainer",
                    attrs: { labelId: "Webheader.company_members" },
                    on: {
                      click: function ($event) {
                        return _vm.goToLink("/accountMembers/")
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("mobile-menu-section-list-item", {
                staticClass: "profileInformationContainer",
                attrs: { labelId: "leftPanelTitle.lgout" },
                on: { click: _vm.logoutWait },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "mobile-menu-container",
            _vm._l(_vm.menu, function (item) {
              return !_vm.isDisabledItem(item) && item.enabled
                ? _c(
                    "mobile-menu-section",
                    {
                      key: item.id,
                      attrs: {
                        headerLabelId: _vm.hasOneRight(item.list)
                          ? item.titleShort
                          : "",
                      },
                    },
                    [
                      item.list
                        ? _c(
                            "div",
                            _vm._l(item.list, function (subItem) {
                              return subItem.id !== 0 &&
                                !_vm.isDisabledItem(subItem) &&
                                subItem.enabled
                                ? _c("mobile-menu-section-list-item", {
                                    key: subItem.id,
                                    staticClass: "ml-20px",
                                    attrs: { labelId: subItem.titleShort },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getClicked(subItem)
                                      },
                                    },
                                  })
                                : _vm._e()
                            }),
                            1
                          )
                        : item.link
                        ? _c(
                            "div",
                            [
                              _c("mobile-menu-section-list-item", {
                                attrs: {
                                  labelId: item.title,
                                  disabled: _vm.isDisabledItem(item),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.goToLink(item.link)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e()
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }